import React from 'react';

import { observer } from 'mobx-react';
import { enqueueSnackbar } from 'notistack';

import classes from './ChallengePublishedModal.module.scss';
import { LbModal } from '../../../../../shared/components/modals/LbModal/LbModal';
import SuccessImage from '../../../../../../../assets/images/vectors/success-rounded.svg';
import { copyTextToClipboard } from '../../../../../shared/utils/apiUtils/copyTextToClipboard/copyTextToClipboard';
import { TextTruncate } from '../../../../../shared/components/ui-components/TextTruncate/TextTruncate';

type ChallengePublishedModalProps = {
  challengeId: number;
  onClose: () => void;
};

const ChallengePublishedModal = observer(
  ({ challengeId, onClose }: ChallengePublishedModalProps) => {
    const challengeLink = `${window.location.origin}/#!/challenge-landing/${challengeId}`;

    const handleCopyLink = () => {
      copyTextToClipboard(challengeLink);
      enqueueSnackbar('Challenge link copied', {
        variant: 'success',
        autoHideDuration: 2000,
      });
      onClose();
    };

    return (
      <LbModal
        open
        icon={
          <div className={classes.iconBox}>
            <img src={SuccessImage} alt="success" />
          </div>
        }
        title="Your challenge is now live!"
        text="Copy the link below to share it with potential participants. The challenge can only be accessed via this link"
        primaryBtnConfig={{ text: 'Copy link', onClick: handleCopyLink }}
        secondaryBtnConfig={{ text: 'Close', onClick: onClose }}
      >
        <div className={classes.linkBox}>
          <div className={classes.label}>Challenge Link</div>
          <TextTruncate text={challengeLink} className={classes.linkValue} />
        </div>
      </LbModal>
    );
  },
);

export { ChallengePublishedModal };
